import styled from 'styled-components';

import { flexEnd } from '../../style/reusableStyle';

export const JobDetailsContainerStyled = styled.div`
  max-width: 930px;
  & .section-title {
    margin-bottom: 20px;
  }
`;

export const ClientReviewAndJobProcessStatusStyled = styled.div``;

export const PDFReviewByClientStyled = styled.div``;

export const CloseAdditionalWrapperStyled = styled.div`
  ${flexEnd(0)};

  & svg {
    cursor: pointer;
    path {
      stroke: red;
    }
  }
`;
